/**
 * @file 节流指令
 */
export default {
    bind: function (el, binding) {
        let fn, event = 'click', time = 1000
        if (typeof binding.value == 'function') {
            fn = binding.value
        } else {
            [fn, event = 'click', time = 1000] = binding.value
        }

        /**
         * el.preTime 记录上次触发事件，
         * 每次触发比较nowTime（当前时间） 和 el.preTime 的差是否大于指定的时间段！
         */
        el.addEventListener(event, () => {
            const nowTime = new Date().getTime()
            if (!el.preTime || nowTime - el.preTime > time) {
                el.preTime = nowTime
                fn()
            }
        })
    }
}

